import React from 'react';

export const TeamIcon: React.FC = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16.25" cy="16.25" r="10.75" fill="#928CDA" />
    <circle cx="23.75" cy="23.75" r="10.75" fill="#FF576D" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.25 27C22.1871 27 27 22.1871 27 16.25C27 15.2582 26.8657 14.2977 26.6142 13.3858C25.7023 13.1343 24.7418 13 23.75 13C17.8129 13 13 17.8129 13 23.75C13 24.7418 13.1343 25.7023 13.3858 26.6142C14.2977 26.8657 15.2582 27 16.25 27Z"
      fill="#92305D"
    />
  </svg>
);
